import gsap from 'gsap'

function headBannerSlider() {
    const wrapper = document.querySelector('.headBanner-wrapper')
    const banners = document.querySelectorAll('.headBanner')
    const container = document.querySelector('.container-headBanner')
    if (!wrapper || banners.length === 0) return

    let bannerHeight = document.querySelector('.headBanner').offsetHeight // px

    let index = 0
    let autoSlideIntervalId

    function showNextBanner() {
        index = (index + 1) % banners.length

        gsap.to(wrapper, {
            y: -index * bannerHeight,
            duration: 1,
            ease: 'power2.inOut'
        })
    }

    function startAutoSlide() {
        autoSlideIntervalId = setInterval(showNextBanner, 3500)
    }

    function stopAutoSlide() {
        clearInterval(autoSlideIntervalId)
    }

    container.addEventListener('mouseenter', () => {
        stopAutoSlide()
    })

    container.addEventListener('mouseleave', () => {
        startAutoSlide()
    })

    if (banners.length > 1) {
        startAutoSlide()
    }
}

window.addEventListener('DOMContentLoaded', headBannerSlider())
